import React from 'react';
import { TextInput, NumberInput, CheckBox } from 'hyperdb-utils';

const SPRABFields = ({ settings, onChange, checkboxesToDisplay = [] }) => {
  const handleClickCheckbox = (attributeName) => {
    const checked = !settings[attributeName];
    onChange(attributeName, { value: checked });
  };
  return (
    <div>
      <TextInput
        label="Local login"
        name="local_login"
        value={ settings.local_login }
        onChange={ onChange.bind(null, 'local_login') }
      />
      <TextInput
        label="Local password"
        name="local_password"
        value={ settings.local_password }
        onChange={ onChange.bind(null, 'local_password') }
      />
      <TextInput
        label="Remote login"
        name="remote_login"
        value={ settings.remote_login }
        onChange={ onChange.bind(null, 'remote_login') }
      />
      <TextInput
        label="Remote password"
        name="remote_password"
        value={ settings.remote_password }
        onChange={ onChange.bind(null, 'remote_password') }
      />
      <TextInput
        label="Remote url"
        name="remote_url"
        value={ settings.remote_url }
        onChange={ onChange.bind(null, 'remote_url') }
      />
      <NumberInput
        label="Price ratio"
        name="price_ratio"
        value={ settings.price_ratio }
        onChange={ onChange.bind(null, 'price_ratio') }
      />
      <div>
        {
          checkboxesToDisplay.map((checkbox, i) => {
            return (
              <CheckBox
                label={ checkbox }
                name={ checkbox }
                checked={ settings[checkbox] }
                onChange={ handleClickCheckbox.bind(null, checkbox) }
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default SPRABFields;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/components/SPRABFields.jsx